import { PaymentReference } from "../modules/accounts/types";
import { calculateInvoiceTotalPaid } from "./calculateInvoiceTotalPaid";

export const calculateInvoiceBalanceAmount = (
    totalAmount: number = 0,
    paymentReferences: PaymentReference[] = [],
    initialReceivedAmount: number = 0
): number => {
    const totalPaid = calculateInvoiceTotalPaid(paymentReferences, initialReceivedAmount);
    return Math.max(0, (totalAmount || 0) - totalPaid);
};